import { Box, Button, Container, Grid, Paper, Popover, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
// import { rows } from '../../masters/MastersFakeDb';
import { NavLink } from "react-router-dom";
import internalMovementprint from "./internalMovementPrint";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import { editDeleteInternalMovement, getInternalMovementList } from "../../../actions/actions";
import internalMovementService from "../../../services/internalMovement.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const ComponentToPrintWrapper = ({ quotationPrint }) => {
    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}> <PrintOutlinedIcon /> <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <internalMovementprint ref={ref} salesOrderPrint={quotationPrint} />
            </div>
        </div>
    );

};
// export { ComponentToPrintWrapper };
const IntermalMovementList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    const totalCount = useSelector(state => state.internal_movement.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.internal_movement.rows_per_page || 15);
    // const rows = useSelector(state => state.internal_movement.internal_movement)
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const fields = [
        'inward_no',
        'inward_type',
        'driver_name',
        'party_name',
        'challan_no'
    ];

    const labels = [
        'Inward No',
        'Inward Type',
        'Driver Name',
        'Party Name',
        'Challan No'
    ];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.charges.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });
    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);


    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await internalMovementService.getInternalMovementList(params);
            setRows(response);
        } catch (error) {
            setSuccessMessage("Error fetching data");
        }
    };

    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);  // Set the search key

        // Prepare the params based on the search value
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: searchValue,
        };

        try {
            // Fetch data using the fetchData function (assuming fetchData is already declared)
            await fetchData(params);
        } catch (error) {
            console.error("Error in handleSearch:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);

    // const deleteRecord = (id) => {
    //     dispatch(editDeleteInternalMovement({ ime_id: id, changedUpdatedValue: 'delete' }))
    //     setIsDelete(false);
    //     fetchData()
    // }
    const deleteRecord = async (id) => {
        try {
            await internalMovementService.editDeleteInternalMovement({
                internal_transfer_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };
    // console.log('data', rows)

    const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.internal_movement.message);

    // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
    //      useEffect(() => {
    //             if (respMsgState) {
    //                 setSuccessMessage(respMsgState);
    //             }
    //         }, [respMsgState]);
    //     useEffect(() => {
    //     }, [shouldShowMsg, responseMessage,]);



    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });





    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Internal Transfer' },
                    ]}
                />


                <HeaderSection
                    title="Internal Transfer Entry List"
                    addNewPath="/storeEntries/add-ime"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Internal Movement Entry List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                    openscanner={true}
                />




                <Paper sx={{ width: '100%',  }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>Entry Date</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`}>Entry No</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>From Location</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>To Location</StyledTableCell>
                                    {/* <StyledTableCell align="left" className={`${styles.table_head}`}>Driver Name </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>Vehicle No</StyledTableCell>*/}
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>No Of Cylinders</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.so_no}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.entry_date}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>  {row.internal_entry_no}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.from_location}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.to_location}</StyledTableCell>
                                        {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.deiver_name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.vehicle_no}</StyledTableCell>*/}
                                        <StyledTableCell align="left" className={styles.list_table_body}>
                                            {(() => {
                                                try {
                                                    const inwardDetails = JSON.parse(row.table_details || '[]');
                                                    const cylNos = inwardDetails.map(cd => cd.cyl_no).filter(Boolean);
                                                    return cylNos.length > 0 ? cylNos.join(', ') : 'No Cylinders';
                                                } catch (error) {
                                                    console.error("Error parsing table_details:", error);
                                                    return "Invalid Data";
                                                }
                                            })()}
                                        </StyledTableCell>

                                        <StyledTableCell align="center">
                                            <CustomePopover row={row} handleDelete={false} linkTo="/storeEntries/add-ime" PrintComponent={internalMovementprint} />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.internal_transfer_id || null}
                    displayName={deleteInfo?.internal_transfer_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    )
}
export default IntermalMovementList;

